import React from "react";

import a1 from "../../../assets/img/about.webp";
function AboutStory({ data, t }) {
  return (
    <>
      <section className="sectionPD">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="videoDetail">
                <h6>Welcome to Vinca Horticulture & Landscaping Pvt. Ltd.</h6>
                <h2>Innovative Landscaping Solutions for Every Space</h2>
                <p>
                  Vinca Horticulture & Landscape Pvt. Ltd. offers tech
                  integrated solutions to craft your landscaping fascination
                  into existence be it for the designing, implementation,
                  supplying and maintenance etc.
                </p>
                <p>
                  Our services are premium and yet affordable as we bring you
                  the panacea for all your “GROUNDSKEEPING” needs by offering
                  tailoring made solutions backed by over a decade of experience
                  of leadership team.
                </p>
                <p>
                  Vinca’s team of dedicated, qualified and skilled professionals
                  value the customers and helps them attaining their desired and
                  cherished results, right from the very beginning till their
                  dreamy products.
                </p>
                <p>
                  The differentiator that makes our services peerless is our
                  commitment, to maintain any property in a pristine state which
                  greatly enhances aesthetic beauty of the property and directly
                  increase its value by utilizing sound horticulture practices
                  and meticulously cares for the property in a sustainable
                  manner to ensure positive conservation measures are
                  implemented.
                </p>
              </div>
            </div>
            {/* <div className="col-lg-5 col-md-12">
              <div className="videoInfo">
                <img
                  src={a1}
                  alt={"Vinca Horticulture & Landscaping"}
                  className="img-fluid"
                />
              </div>
            </div> */}
          </div>
        </div>
      </section>
    </>
  );
}

export default AboutStory;
